import { css } from "@emotion/react";
import { FC, useEffect } from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { ReportType } from "constants/reports/report-type";
import { trackUpgradeButtonClicked, trackUpsellViewDisplayed } from "helpers/analytics-reports";
import { withVar } from "themes/helpers";

import { LinkButton } from "./LinkButton";

const containerStyles = css`
  padding: 45px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const contentWrapperStyles = css`
  max-width: 310px;
  padding: 35px 15px;
`;

const titleStyles = css`
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${withVar(DesignToken.ContentBasicPrimary)};
`;

const descriptionStyles = css`
  margin-bottom: 20px;
  font-size: 15px;
  font-weight: 400;
  line-height: 21px;
  color: ${withVar(DesignToken.ContentBasicSecondary)};
`;

const buttonStyles = css`
  padding: 0 36px;
  line-height: 36px;
`;

interface IProps {
  image?: string;
  title?: string;
  description?: string;
  trackingName?: string | ReportType;
}

export const Upsell: FC<IProps> = ({ image, title, description, trackingName }) => {
  useEffect(() => {
    // @ts-expect-error TS(2345): Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
    trackUpsellViewDisplayed(trackingName);
  });

  return (
    <div css={containerStyles}>
      {image && (
        <div>
          <img src={image} width="300" />
        </div>
      )}
      <div css={contentWrapperStyles}>
        {title && <div css={titleStyles}>{title}</div>}
        {description && <div css={descriptionStyles}>{description}</div>}
        <div>
          <LinkButton
            href="/subscription"
            css={buttonStyles}
            // FIXME: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
            onClick={trackingName ? () => trackUpgradeButtonClicked(trackingName) : undefined}
          >
            Upgrade plan
          </LinkButton>
        </div>
      </div>
    </div>
  );
};
